import { patientTopCard } from '@shared/helpers/pdf-patient-card.helper';
import { MagistralRecipe } from '@shared/interfaces/recipe-magistral.interface';
import { getUnit } from '../constants/posologies.const';

/**
 * Construye el contenido del PDF para recetas magistrales.
 *
 * @description
 * Genera la estructura de contenido para el documento PDF de recetas magistrales
 * (preparaciones farmacéuticas personalizadas). Formatea la información de cada fórmula
 * incluyendo composición química, CSP (Cantidad Suficiente Para), posología, frecuencia,
 * duración del tratamiento y observaciones.
 *
 * @param {any} paperwork - Objeto del trámite que contiene información del paciente, profesional y recetas
 * @param {any} group - Grupo de prescripciones magistrales con sus filas (rows)
 * @returns {any[]} Array con la estructura de contenido formateada para pdfmake
 *
 * @remarks
 * Características del PDF generado:
 * - Incluye tarjeta de paciente al inicio del documento
 * - Lista los compuestos químicos de cada fórmula magistral
 * - Especifica CSP (Cantidad Suficiente Para) con unidad de medida
 * - Formatea posología con pluralización correcta de unidades
 * - Maneja tratamientos permanentes y SOS sin mostrar cantidad de duración
 * - Incluye fecha de inicio de tratamiento en formato DD-MM-YYYY
 * - Agrega salto de línea entre recetas para mejor legibilidad
 *
 * @example
 * const pdfContent = buildContentPdfRecipesMegistral(paperwork, { rows: magistralPrescriptions });
 */
export const buildContentPdfRecipesMegistral = (paperwork, group) => {

  const row = group.rows;
  const recipeBuildPdf = row.map((itemForm: MagistralRecipe) => {
    const { observations, start } = itemForm;
        const {duration, each, posology} = itemForm;
        const {csp, compounds} = itemForm;


        const COMPOSITION = {text: `${compounds}`, bold: true, fontSize: 10, alignment: 'justify'};
        if (!compounds) COMPOSITION.text = '';

      const CSP = csp
        ? {
            text: `C.S.P.: ${csp.quantity} ${getUnit(csp.unit, csp.quantity)}`,
            bold     : true,
            fontSize : 10,
            alignment: 'justify',
        } : { text: '' };

      const hasDurationQuantity = !['permanente', 'sos'].includes(duration.unit.toLocaleLowerCase());
        const DURATION = {
            text:
              `Aplicación: ${posology.quantity} ${getUnit(posology.unit, posology.quantity)} ` +
              `cada ${each.quantity} ${getUnit(each.unit, each.quantity)} ` +
              `por ${hasDurationQuantity ? duration.quantity : ''} ${getUnit(duration.unit, duration.quantity)}`,
        };
        const START_TREATMENT = {
          text: `Inicio del Tratamiento: ${(start || '').toString().split('-').reverse().join('-')}`,
        };

      const OBSERVATIONS = observations
        ? { text: `Observaciones: ${observations}`, margin: [0, 0, 0, 10], alignment: 'justify' }
        : { text: '' };

        return [
            {
                ul    : [COMPOSITION],
                margin: [0, 10, 0, 0],
            },
            {
                fontSize: 10,
                type    : 'none',
                ol      : [CSP, DURATION, START_TREATMENT, OBSERVATIONS],
            },
            '\n',
        ];
    });
    return [...patientTopCard(paperwork), recipeBuildPdf];
};
